/** Display label from Supabase Auth user (metadata or email). */
export function labelFromUser(user) {
  if (!user) return "User";
  const meta = user.user_metadata || {};
  const name =
    meta.full_name ||
    meta.name ||
    meta.display_name ||
    (typeof meta.full_name === "string" ? meta.full_name : null);
  if (name && String(name).trim()) return String(name).trim();
  const email = user.email;
  if (email) return email.split("@")[0] || email;
  return "User";
}
